import { call, put, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import errorHandler from "common/errorHandler";
import * as actions from "./actions";

// No tenantid header — the tenant is determined server-side from the auth-token claims.

const rulesetUrl = (businessAreaId, schemaId) => `${Endpoints.datasets}/api/v1/businessareas/${businessAreaId}/schemas/${schemaId}/survivorship`;

export function* getSurvivorshipRulesetRequest(api, action) {
    try {
        const { businessAreaId, schemaId } = action.params;
        const result = yield call([api, api.get], rulesetUrl(businessAreaId, schemaId));
        yield put(actions.getSurvivorshipRulesetSuccess(result.data));
    } catch (error) {
        if (error.isAxiosError && error.response && error.response.status === 404) {
            // No ruleset configured yet for this schema — not an error.
            yield put(actions.getSurvivorshipRulesetSuccess(null));
            return;
        }
        yield put(actions.getSurvivorshipRulesetFailure(errorHandler(error, "Get", "survivorship ruleset")));
    }
}

export function* saveSurvivorshipRulesetRequest(api, action) {
    try {
        const { businessAreaId, schemaId, ruleset } = action.params;
        const result = yield call([api, api.put], rulesetUrl(businessAreaId, schemaId), ruleset);
        yield put(actions.saveSurvivorshipRulesetSuccess(result.data));
    } catch (error) {
        yield put(actions.saveSurvivorshipRulesetFailure(errorHandler(error, "Save", "survivorship ruleset")));
    }
}

export function* getSurvivorshipDataSetsRequest(api, action) {
    try {
        const { businessAreaId, schemaId } = action.params;
        const result = yield call([api, api.get], `${Endpoints.datasets}/api/v1/businessareas/${businessAreaId}/schemas/${schemaId}/datasets`);
        yield put(actions.getSurvivorshipDataSetsSuccess((result.data && result.data.Items) || []));
    } catch (error) {
        yield put(actions.getSurvivorshipDataSetsFailure(errorHandler(error, "Get", "schema datasets")));
    }
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_SURVIVORSHIP_RULESET_REQUEST, getSurvivorshipRulesetRequest, api);
    yield takeLatest(actions.SAVE_SURVIVORSHIP_RULESET_REQUEST, saveSurvivorshipRulesetRequest, api);
    yield takeLatest(actions.GET_SURVIVORSHIP_DATASETS_REQUEST, getSurvivorshipDataSetsRequest, api);
}
